import { render, staticRenderFns } from "./EscanerGuiasIndex.vue?vue&type=template&id=4834640e"
import script from "./EscanerGuiasIndex.vue?vue&type=script&lang=js"
export * from "./EscanerGuiasIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports